import M2Request from '../../library/M2Request';

const Endpoints = {
    "get": "feeds/",
    "read": "feeds/readed/",
    "bookmark": "feeds/bookmark/",
    "bookmark_list": "feeds/bookmarks",
    "bookmark_remove": "feeds/bookmarks",
    "feed": "feeds/"
};


export function loadFeed(item_id) {
    return M2Request(Endpoints.feed + item_id, "GET");
}

export function removeBookmarks(items) {
    return M2Request(Endpoints.bookmark_remove, "DELETE", {items: items});
}


export function loadBookmarks(filter) {
    let url = Endpoints.bookmark_list;
    let options = [];
    if(filter) {
        for(var i in filter) {
            options.push(i + '=' + filter[i]);
        }
    }

    if(options && options.length > 0) {
        url += '?' + options.join('&');
    }
    return M2Request(url, "GET");
}


export function addReadedPost(id) {
    return M2Request(Endpoints.read + id, "POST");
}

export function addBookmark(id) {
    return M2Request(Endpoints.bookmark + id, "POST");
}


export function loadList(page = 0, filter = {}) {
    let url = Endpoints.get;
    let params = [];

    if(page && page > 0) {
        params.push('page=' + page);
    }

    if(filter) {
        for(var i in filter) {
            params.push(i + '=' + filter[i]);
        }
    }

    if(params.length > 0) {
        url += '?' + params.join('&');
    }

    return M2Request(url, "GET");
}


// WEBPACK FOOTER //
// ./src/models/feeds/api.js